<template>
  <div>
    <div class="page-header page-header-small clear-filter">
      <parallax
        class="page-header-image"
        style="background-image:url('img/login.jpg')"
      >
      </parallax>
        <div class="content-center brand">
          <h1 class="h1-seo">Funds</h1>
        </div>
    </div>

    <section id="terms" class="section" v-if="!view">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">This site is intended for the use of investors in The Netherlands only. Please read and accept the following disclaimer</h2>
            <n-checkbox v-model="agree">I have read and accept the following disclaimer:</n-checkbox>
            <n-button v-if="agree" type="primary" @click="view = true">Go to Fund</n-button>  
              <h3 class="text-primary pt-4 mb-2">NOG AAN TE LEVEREN: TEKST DISCLAIMER</h3>
              </div>
          </div>
        </div>
      </section>
      <section id="funds" class="section" v-if="agree && view">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Pandion Fund</h2>
             <ul>
                <li v-for="doc in pandionDocs" :key="doc.title"><a :href="/docs/ + doc.document" target="_blank">{{doc.title}}</a></li>
            </ul>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Alpha Based Capital</h2>
             <ul>
                <li v-for="doc in docs" :key="doc.title"><a :href="/docs/ + doc.document" target="_blank">{{doc.title}}</a></li>
            </ul>
          </div>
          <div class="col-md-12 col-lg-8" style="margin-top:24px;">
            <p>All mandatory information can be provided on request with a copy and, if applicable, the costs involved.</p>
             <p>The Fund Manager shall prepare a monthly statement containing an explanation of: (i) the total value of the investments of the Fund; (ii) an overview of the composition of such investments; (iii) the number of outstanding Participations; and (iv) the most recently determined net asset value of the Participations, indicating when the determination of the net asset value took place and with a period of at least one week between the times of preparation, and shall publish such statement on its website for the benefit of the Participants. The statement shall be co-signed by the Custodian. The Fund Manager shall provide this statement to Participants upon request at cost price.</p>
          </div>
        </div>
        </div>
      </section>
    </div>
</template>
<script>
import { Parallax } from '@/components';
import {
  Checkbox,
  Button
} from '@/components';
export default {
  data() {
    return {
      agree: true, // to update when disclaimer available
      view: true, // to update when disclaimer available,
      pandionDocs: [
        {
          title: 'Overzicht fondsen juli 2025',
          document: '20250731 -  OVERZICHT FONDSEN ALPHA BASED CAPITAL FUND MANAGEMENT  BV.pdf'
        },
        {
          title: 'Halfjaarverslag 2025  Pandion BBDGF',
          document: '20250827 - Pandion BBDGF_30062025_v3a.pdf'
        },
        {
          title: 'Halfjaarverslag 2025  Pandion PWF',
          document: '20250827 - Pandion PWF_30062025_v3a.pdf'
        },
        {
          title: 'Halfjaarverslag 2025  Pandion DBFF',
          document: '20250827 - DB Flagship Fund - Semi Annual 2025 V2.pdf'
        },
        {
          title: 'Jaarverslag 2024 BBDGF',
          document: '20250609 - Jaarverslag Pandion BBDGF 2024  -SIGNED.pdf'
        },
        {
          title: 'Jaarverslag 2024 PWF',
          document: '20250609 - Jaarverslag Pandion PWF 2024  -SIGNED.pdf'
        },
        {
          title: 'Jaarverslag 2024 DBFF',
          document: '20250626 - Jaarverslag Pandion DBFF 2024 -SIGNED.pdf'
        },
        {
          title: 'Halfjaarverslag 2024 Pandion GSELS',
          document: 'Pandion Global Sustainable Equity Long Short HY draft FS 30 June  2024_v3.pdf'
        },
        {
          title: 'Halfjaarverslag 2024 Pandion BBDGF',
          document: 'Pandion Beleggers Belangen Dividend Groei Fonds HY  Report_063024_v3.pdf'
        },
        {
            title: 'Jaarverslag 2023 GSELS',
            document: 'Pandion GSELS - Jaarsverslag 2023.pdf'
        },
        {
          title: 'Jaarverslag 2023 BBDGF',
          document: 'Pandion BBDGF - Jaarverslag 2023.pdf'
        },
        {
          title: 'PROPOSED AMENDMENTS TO PANDION FUND PROSPECTUS AND TERMS AND CONDITIONS Pandion PWF',
          document: 'Bijlage 2 - Pandion - Amendment Prospectus - Proposed Amendment -  18.11.25.pdf'
        },
        {
          title: 'Prospectus Pandion Fund (05-12-2024)',
          document: '20241205 - Pandion Fund - Prospectus.pdf'
        },
        {
          title: 'Red-line Prospectus Pandion Fund 16-10-2024 vs 05-12-2024',
          document: '20241205 - Redline - Pandion Fund - Prospectus - 16 October 2024 and Pandion Fund - Prospectus - 5 December 2024.pdf'
        },
        {
          title: 'Notification Explanation Amendment Prospectus (06-12-2024)',
          document: '20241206 - Pandion - Amendment Prospectus - Notification Explanation - 06.12.24.pdf'
        },
        {
          title: 'Subscription Form Pandion Fund',
          document: '20241016 - Pandion Fund - Subscription Form .pdf'
        },
        {
          title: 'EID DB Flagship Fund',
          document: 'Essentiële-informatiedocument - DB Flagship Fund.pdf'
        },
        {
          title: 'EID Beleggers Belangen Dividend Groei Fonds',
          document: '20230523 - Essentiële-informatiedocument - Pandion Fund - BBDGF.pdf'
        },
        {
          title: 'EID Pandion Protective World Fund (NED)',
          document: '20250217 - Essentiële-informatiedocument - Pandion Fund - PPWF.pdf'
        },
        {
          title: 'EID Pandion Protective World Fund (ENG)',
          document: '20250217 - Essentiële-informatiedocument - Pandion Fund - PPWF (ENG).pdf'
        },
        {
          title: 'KvK Stichting Juridisch Eigenaar Pandion',
          document: '20230629 - KvK Uittreksel Stichting Juridisch Eigenaar Pandion.pdf'
        },
        {
          title: 'KvK Stichting Juridisch Eigenaar Duurzaam Beleggen Fondsen',
          document: 'uittreksel_handelsregister_82027498.pdf'
        },
        {
          title: 'Statement Pandion Fund VAT',
          document: '20230630 - Statement ABC.pdf'
        },
        {
          title: 'SFDR website disclosure Pandion Fund PWF',
          document: 'website informatie Pandion Fund PWF 04032025.docx'
        },
        {
          title: 'SFDR website disclosure Pandion DB Flagship Fund',
          document: 'website informatie Pandion Fund DBFF 04032025.docx'
        },
        {
            title: 'Halfjaarverslag 2023 Pandion Fund GSELS',
            document: 'Halfjaarverslag 2023 Pandion GSELS.pdf'
        },
      ],
      docs: [
        {
          title: 'Liquidatie Jaarverslag 2023',
          document: 'Alpha Based Capital Fonds - Liquidatieverslag 2023.pdf'
        }
      ]
    }
  },
  name: 'index',
  bodyClass: 'index-page',
  components: {
    Parallax,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
  }
};
</script>
<style></style>

